import React from "react";
import Skeleton from "@mui/material/Skeleton";

const AvatarSkeleton = ({ children, loading = false }: { children?: React.ReactNode; loading?: boolean }) => {
    if (loading) {
        return <Skeleton variant="circular" width={40} height={40} />;
    }
    return <>{children}</>;
};

export default AvatarSkeleton;